import * as React from 'react';
import classnames from 'classnames';
import * as Styles from './error-page.module.less';
import { PageFooter } from '../page-footer/page-footer';

export type ErrorPageType = 'not-found' | 'expired-link';

export const ErrorPage: React.FC<{ type: ErrorPageType }> = ({ type }) => {
    let imgName: string;
    let title: string;
    let subtitle: string;
    if (type === 'not-found') {
        imgName = 'hotAirBalloon';
        title = 'Uh-oh you’re lost';
        subtitle = 'We can’t seem to find the page you’re looking for.';
    } else if (type === 'expired-link') {
        imgName = 'stopwatch';
        title = 'Whoops';
        subtitle = 'This link has expired';
    } else {
        throw `Invalid type ${type}`;
    }

    return (
        <div className={classnames('page', Styles.page, 'qa-error-page-main-div')}>
            <div
                className={classnames(
                    'page-content',
                    Styles.pageContent,
                    'qa-error-page-container-div'
                )}
            >
                <img
                    className="qa-error-page-image"
                    src={`/assets/images/${imgName}.png`}
                    srcSet={`/assets/images/${imgName}.png, /assets/images/${imgName}@2x.png 2x, /assets/images/${imgName}@3x.png 3x`}
                />
                <div className={classnames(Styles.title, 'qa-error-page-title')}>{title}</div>
                <div className={classnames(Styles.subtitle, 'qa-error-page-subtitle')}>
                    {subtitle}
                </div>
            </div>
            <div className={classnames('space-filler', 'qa-error-page-space-filler')} />
            <PageFooter />
        </div>
    );
};
